 /* eslint-disable */
var _ = require('lodash');


const COLOURS = ["rgb(61, 103, 154)", "rgb(110, 188, 228)", "rgb(168, 221, 181)"];

const loader = {
  getColor: function(index) {
    return COLOURS[index];
  },
  processTabData: function(component, name, data) {
    var chart = loader.formatDataForChart(data, component.data_definition[name]['pivot']);
    return chart;
  },
  formatDataForChart: function(content, key_string) {
    if (key_string === undefined)
      return content;

    var first_item = _.get(content, '[0]', {})
    var column_labels = []
    for (var label in first_item) {
      if(label !== key_string) {
        column_labels.push(label);
      }
    }
    var labels = content.map(function(d) {
      return d[key_string];
    });
    var datasets = [];
    for (var i in column_labels) {
      datasets.push({
        label: column_labels[i],
        data: content.map(function(d) { return (+d[column_labels[i]] * 100) }),
        fill: false,
        backgroundColor: loader.getColor(i)
      })
    }
    var chart_data = {
      labels: labels,
      datasets: datasets
    };

    return chart_data;
  }
};

export default loader;



// WEBPACK FOOTER //
// ./src/modules/chartJsLoader.js